
export interface OverallStoreState {
    allData: any;
}

export enum OverallStoreEnum {
    allData = 'allData',
}
